// src/hooks/useEstimateForm.ts
import { useState } from "react";
import { CoverForm, defaultCoverForm } from "../contracts/estimates/types.ts";
import { useEstimateApi } from "./useEstimateApi.ts";

const API_BASE = process.env.REACT_APP_API_BASE;

export default function useEstimateForm(initial: CoverForm = defaultCoverForm) {
  // TODO: Need to apply useApi
  const [coverForm, setCoverForm] = useState<CoverForm>(initial);
  const [coverPdfBlob, setCoverPdfBlob] = useState<Blob | null>(null);
  const [coverLoading, setCoverLoading] = useState(false);

  // 목적(checkbox) 값 전용 헬퍼
  const extractKey = (name: string) =>
    name.includes(".") ? name.split(".").pop()! : name;

  // CoverFormChange
  const handleChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    const { name, value } = e.target;
    const key = extractKey(name)

    setCoverForm((prev) => ({ ...prev, [key]: value }));
  };

  const handlePurposeChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    const { name, checked } = e.target;
    const key = extractKey(name);      // "purpose.cbEmergency" → "cbEmergency"

    setCoverForm((prev) => ({
      ...prev,
      purpose: {
        ...prev.purpose,
        [key]: checked,                // 원하는 필드만 갱신
      },
    }));
  };

  // EstimateFormChange

  const handleSubmit = async (e) => {
      e.preventDefault();
      try {
          const res = await fetch(`${API_BASE}/estimate/data/insert`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
              ...coverForm,
              })
          });

          if (res.ok) {
              alert("등록 성공!");
              setCoverForm(coverForm);
          } else {
              alert("등록 실패");
          }
      } catch (err) {
      console.error("요청 오류:", err);
      alert("에러 발생");
      }
  };

  return { 
    coverForm, setCoverForm,
    coverLoading, setCoverLoading,
    coverPdfBlob, setCoverPdfBlob,
    handleChange, handlePurposeChange,
    handleSubmit
  };
}
